const signupForm = document.getElementById("signup-form");
const signupLinks = document.querySelectorAll(".signup-link");
const signUpCloseButton = signupForm.querySelector(".signup-link");

const toggleSignupForm = () => {
	const ariaExpanded = signupForm.getAttribute("aria-expanded");
	document.body.classList.toggle("no-scroll", ariaExpanded === "false");
	if (ariaExpanded === "false") {
		signupForm.setAttribute("aria-expanded", "true");
		return;
	}
	signupForm.setAttribute("aria-expanded", "false");
};

Array.from(signupLinks)?.map((signUpLink) => {
	signUpLink.addEventListener("click", () => {
		toggleSignupForm();
	});
});

signUpCloseButton.addEventListener("click", () => {
	localStorage.setItem("brd_seen_signup_subscribed", true);
});

subscribe_status = localStorage.getItem("brd_seen_signup_subscribed");
if (!subscribe_status) {
	setTimeout(function () {
		toggleSignupForm();
		localStorage.setItem("brd_seen_signup_subscribed", true);
	}, 30000);
}
